import { ExternalCompanyIdEnum } from "@/shared/constants/external-company-id.enum";

export const statisticsTemplateClientColor: any = {
  [ExternalCompanyIdEnum.SORMEGLEREN]: {
    firstColor: '#2D0503',
    secondColor: '#FF4238',
  },
}